import { AutoComplete, Input, Tooltip, Breadcrumb, message, Select } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, AscRed, DescGrey, CloseIconSearch, PUrgent, PHigh, PMedium, PLow, MartLogo, LogLogo, DeleteDisabled } from "../../../asset";
import style from "./OrderRequestList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { onChanged, permissionButton } from "../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../component/select/SelectOption";

const OrderRequestList = (props) => {
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const location = useLocation()
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] =useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);
  const [load, setLoad] = useState(false)
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState(); 
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const dispatch = useDispatch()
  const { permission } = useSelector((state) => state.auth);
    
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_ORDER_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGetParam(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}

  const fetchData = async (data, pages) => {
    setLoad(true)
    console.log("fil", filter);
    console.log("data", data);
    let id = 1;
    let res2 = await doGetParam(
      `/depot-list-filter?page=1&limit=10&${param}`,
      token
    );
    if(!res2?.data?.payload?.data){
      setLoad(false)
    }else{
    let res = await doGet(
      `/order?page=${pages ? pages :page}&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", customer_name lk " + filter : data ? ", customer_name lk "+ data : ""}&${param}`,
      token)
    let init = await doGet(
      `/order/initiate?page=${pages ? pages :page}&limit=${limit}&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", customer_name lk " + filter : data ? ", customer_name lk "+ data : ""}&${param}`,
      token)
    setListData(res?.data?.payload?.data);
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
      setDropdown(selectOption(currentDepot, option, "value"));
    
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setInitiate(init?.data?.payload?.data);
    setListData(res?.data?.payload?.data);
    setLoad(false)
  }
  };

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page,limit,filter, depot,depotName, listRecommendation]);

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      console.log("sini g");
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleEdit = (id) => {
    navigate(ROUTES.ORDER_REQUEST.EDIT, { state: id });
  };

  const handleAdd = (id) => {
    navigate(ROUTES.ORDER_REQUEST.ADD, { state: depot ? depot : depot1 });
  };

  const handleDetail = (id, status) => {
    navigate(ROUTES.ORDER_REQUEST.DETAIL, { state: {id:id, status:status} });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const dataSource = listData
    ? listData.map((result) => ({
      order_by: (
        <span className="font-roboto text-lg text-[#222222]">
          {/* {result?.order_by} */}
          <img src={result?.order_by === "Gromart" ? MartLogo : LogLogo} alt="log"/>
        </span>
      ),
        order_id: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order_id}
          </span>
        ),
        order_number: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order_number}
          </span>
        ),
        customer_name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.customer_name}
          </span>
        ),
        address: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.address}
          </span>
        ),
        order_date: (
          <span className="font-roboto text-lg text-[#222222]">
            {moment.parseZone(result?.order_date).locale("id").format("DD/MM/YYYY")} | {moment.parseZone(result?.order_date).locale("id").format("HH:mm")}
          </span>
        ),
        priority: (
          <span className="font-roboto text-lg text-[#222222]">
            {/* {result?.priority} */}
            <img src={result?.priority === 1 ?PUrgent: result?.priority===2 ? PHigh: result?.priority===3?PMedium:PLow} alt="prio"/>
          </span>
        ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.status}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            {/* <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip> */}
            <Tooltip 
        title={t("Delete")} color="#CF0000" className={result?.status === "New" && result?.order_by !== "Gromart" ? "cursor-pointer" : "cursor-not-allowed"}>
              <button onClick={result?.status === "New" && result?.order_by !== "Gromart" ? () => setModal(result) : ""}>
                <img src={result?.order_by === "Gromart" ? DeleteDisabled :DeleteIcon} alt="del" />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.id, result?.updated_at)}
                onClick={() => handleDetail(result?.order_id, result?.status)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

    const doSort = async (sort) => {
      setSorting(sort);
    
      if (sort) {
      setSorting(sort);
        // fetchData();
        
      fetchData(data, sort);
        // this.setState({ loading: true });
        // await this.setState(
        //   {
        //     orderby: `${code+" "+sort}`,
        //     pageProductivitySalesman:1,
        //   }
        // )
      }
    };

  const ListColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
        {t("Order By")}
      </span>
      ),
      dataIndex: "order_by",
      key: "order_by",
      render: (order_by) => <span>{order_by}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
        {t("Order ID")}
      </span>
      ),
      dataIndex: "order_id",
      key: "order_id",
      render: (order_id) => <span>{order_id}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order Number")}
        </span>
      ),
      dataIndex: "order_number",
      key: "order_number",
      render: (order_number) => <span>{order_number}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Customer Name")}
        </span>
      ),
      dataIndex: "customer_name",
      key: "customer_name",
      render: (customer_name) => <span>{customer_name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Address")}
        </span>
      ),
      dataIndex: "address",
      key: "address",
      render: (address) => <span>{address}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order Date")}
        </span>
      ),
      dataIndex: "order_date",
      key: "order_date",
      render: (order_date) => <span>{order_date}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Priority")}
        </span>
      ),
      dataIndex: "priority",
      key: "priority",
      render: (priority) => <span>{priority}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Status")}
        </span>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];
  const handlePagination = (a,b)=>{
    console.log(a,b);
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
    let res = await doGet(`/order/search?page=1&limit=10&filter=depot_id eq ${depot ? depot : depot1}, customer_name lk ${filters}&${param}`, token);
    setListRecommendation(res?.data?.payload?.data);

    }
  };

  const handleChange = (value, id) => {
    setDepot(value);
    setDepotName(value);
    fetchData("",1);
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value)
    setIsfilter(true)
    if (value) {
      setSearchRecommedation(value)
      await fetchRecommendation(1,10,value)
    } else {
    }
  };

  const onSelectRecommendation =(data) => {
    setPage(1)
    setFilter(data)
    fetchData(data, 1)
    setIsfilter(false)
    setListRecommendation("")
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setInitiate([])
    setSearchRecommedation("");
    setListRecommendation("");
    fetchData("",1);
  };

  console.log("listrec", listRecommendation);

  // const options =
  //     listRecommendation &&
  //     listRecommendation?.map((item) => ({
  //       value: item.value,
  //       label: item.value,
  //     }));

  return (
    <>
      <Delete
        data={data.updated_at}
        id={data.order_id}
        delete={showDelete}
        title={data?.customer_name}
        url={"order"}
        action={() => setShowDelete(false)}
        refresh={()=>fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>Order Request</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Order Request")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex">
         <AutoComplete
                 options={ listRecommendation &&
                  listRecommendation?.map((item) => ({
                    value: item.value,
                    label: item.value,
                  }))}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search Customer Name")}
                className="w-[350px] h-[47px]"
                height={47}
                width={350}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                // options={options}
                value={searchRecommendation}
                // onChange={(value) => onSearchRecommendation(value)}
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[200px]"}
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
              >
              {!loading
                  ? dropdown
                  : [...dropdown, LoadingOption()]}
              </Select>
            </div>

          {/* <Link to={ROUTES.ORDER_REQUEST.ADD}> */}
            <PrimaryButton
            disabled={dropdown.length===0 || load}
              text={t("Add Order Request")}
              prefixIcon={<AddIcon />}
              action={() => handleAdd()}/>
          {/* </Link> */}
        </div>

        {
  !load ?
        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        : "...loading"}
      </div>
    </>
  );
};

export default OrderRequestList;
